import { Skeleton } from '@iheartjane/reefer';

import { ProductsSkeleton } from '@jane/bloom/components/skeletonLoaders/productsSkeleton';

import styles from './categoryPageSkeleton.module.css';

export const CategoryPageSkeleton = () => (
  <main className={styles['mainCategory']} data-testid="category-skeleton">
    <Skeleton animate className={styles['rowHeader']}>
      <Skeleton.Bone className={styles['productCount']} />
    </Skeleton>

    <ProductsSkeleton count={10} />
  </main>
);
